import React, { useEffect, useState } from 'react';
import './App.css';
import { Loader } from './Loader';

const MainSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slideImages, setSlideImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const intervalDuration = 20000;

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Витрина релизов METRIKA из кабинета. Прежний workflow Bubble на
        // paradigm-music.ru после переезда 30.09.2026 отвечает 404.
        const response = await fetch('https://lk.metrikamusic.com/api/smartlinks/label/metrika');

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        const imageUrls = data.response.coverArt.slice(0, 6);
        setSlideImages(imageUrls);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveSlide(prev => (prev === slideImages.length - 1 ? 0 : prev + 1));
    }, intervalDuration);
    return () => clearInterval(intervalId);
  }, [slideImages]);

  if (loading) {
    return (
      <Loader />
    );
  }

  if (error) return <div>Error: {error.message}</div>;
  if (slideImages.length === 0) return <div>No available images</div>;

  return (
    <div className="slider-container">
      {slideImages.map((url, i) => (
        <div
          key={i}
          className={`slider-item ${i === activeSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${url})` }}
        />
      ))}

      <button className="slider-btn prev" onClick={() => setActiveSlide(prev => (prev === 0 ? slideImages.length - 1 : prev - 1))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6" /></svg>
      </button>

      <button className="slider-btn next" onClick={() => setActiveSlide(prev => (prev === slideImages.length - 1 ? 0 : prev + 1))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg>
      </button>

      <div className="slider-dots">
        {slideImages.map((_, i) => (
          <span key={i} className={`dot ${i === activeSlide ? 'active' : ''}`} onClick={() => setActiveSlide(i)} />
        ))}
      </div>
    </div>
  );
};

export default MainSlider;
